import React from 'react';
import { ChevronLeft, ChevronRight } from '@videoblocks/react-icons';
import { ELLIPSIS } from '../utils/pagination';
import usePagination from '../hooks/usePagination';
import PaginationButton from './Pagination/PaginationButton';
import EllipsisSeparator from './Pagination/EllipsisSeparator';
import { twMerge } from 'tailwind-merge';
const Pagination = ({
  activePage,
  disabled = false,
  getHref = () => undefined,
  maxButtons,
  onPageSelect = () => undefined,
  prefix = '',
  terminalButtons,
  totalPages
}) => {
  const pages = usePagination({
    activePage,
    maxButtons,
    terminalButtons,
    totalPages
  });
  if (pages.length === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  const getPageId = page => {
    return !!prefix ? `${prefix}-page-${page}` : `page-${page}`;
  };
  const getEllipsisId = index => {
    return !!prefix ? `${prefix}-ellipsis-${index}` : `ellipsis-${index}`;
  };
  const getPreviousPageId = () => {
    return !!prefix ? `${prefix}-previous-page` : 'previous-page';
  };
  const getNextPageId = () => {
    return !!prefix ? `${prefix}-next-page` : 'next-page';
  };
  const goToPage = (event, pageNumber) => {
    event.preventDefault();
    onPageSelect(pageNumber);
  };
  const getClassName = page => {
    if (page !== activePage) return '';
    if (page === totalPages) return 'rounded-r-lg';
    if (page === 1) return 'rounded-l-lg';
    return '';
  };
  const PreviousPage = () => /*#__PURE__*/React.createElement(PaginationButton, {
    id: getPreviousPageId(),
    className: "rounded-1-md font-bold border-r border-gray-400",
    href: getHref(activePage - 1),
    onClick: event => goToPage(event, activePage - 1),
    disabled: disabled
  }, /*#__PURE__*/React.createElement(ChevronLeft, {
    className: twMerge('w-4 h-4 fill-current', disabled ? 'text-gray-500' : 'text-blue-700')
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Previous Page"));
  const NextPage = () => /*#__PURE__*/React.createElement(PaginationButton, {
    id: getNextPageId(),
    disabled: disabled,
    className: "rounded-r-md font-bold border-l border-gray-400",
    href: getHref(activePage + 1),
    onClick: event => goToPage(event, activePage + 1)
  }, /*#__PURE__*/React.createElement(ChevronRight, {
    className: twMerge('w-4 h-4 fill-current', disabled ? 'text-gray-500' : 'text-blue-700')
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Next Page"));
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-full my-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-nowrap w-max flex items-center justify-center border border-gray-400 border-solid rounded-md"
  }, activePage > 1 && /*#__PURE__*/React.createElement(PreviousPage, null), pages.map((page, index) => {
    const id = getPageId(page);
    return page === ELLIPSIS ? /*#__PURE__*/React.createElement(EllipsisSeparator, {
      key: getEllipsisId(index),
      disabled: disabled
    }) : /*#__PURE__*/React.createElement(PaginationButton, {
      key: id,
      id: id,
      disabled: disabled,
      isActive: activePage === page,
      className: getClassName(page),
      href: getHref(page),
      onClick: event => goToPage(event, page)
    }, page);
  }), activePage < totalPages && /*#__PURE__*/React.createElement(NextPage, null)));
};
export default Pagination;